module.exports = __webpack_public_path__ + "img/img-personaliza.a33039b8.webp";